<table class="table table-bordered table-hover">
  <thead class="table-dark">
    <tr>
      <th>CLAIM ID</th>
      <th>STATUS</th>
      @if (displayClient) {
        <th>CLIENT</th>
      }
      <th>SOURCE</th>
      <th class="text-center">ESTIMATED VALUE</th>
      @if (internalConsultantView) {
        <th class="text-center">PATIENT ESTIMATED VALUE</th>
      }
      @if (!internalConsultantView) {
        <th class="text-center">MANUAL FAX</th>
      }
      <th class="text-end">CREATED ON</th>
      <th class="text-end">EXPIRES ON</th>
      @if (!internalConsultantView) {
        <th class="text-end">VERIFIED ON</th>
      }
      @if (displayPatient) {
        <th>CE-PATIENT</th>
      }
      <th>RX-PATIENT</th>
      @if (displayProvider) {
        <th>PRESCRIBER</th>
      }
      <th>DRUG</th>
    </tr>
  </thead>
  <tbody>
    @for (capture of captureQueueResults; track capture) {
      <tr>
        <td>
          @if (!openInNewTab) {
            <a routerLink="/capture-admin/captures/{{capture.id}}">
              <span class="text-nowrap">{{ capture.candidate.claimIdentifier }}</span>
            </a>
          }
          @if (openInNewTab) {
            <a routerLink="/capture-admin/captures/{{capture.id}}" target="_blank">
              <span class="text-nowrap">{{ capture.candidate.claimIdentifier }}</span>
            </a>
          }
          @if (capture.status === captureStatus.ceReview && capture.hasClientPrescriberTask) {
            <div>
              <span class="badge bg-success fw-normal rounded-0">Client Prescriber Task</span>
            </div>
          }
          @if (capture.status === captureStatus.ceReview && capture.hasClientReferralTask) {
            <div>
              <span class="badge bg-success fw-normal rounded-0">Client Referral Task</span>
            </div>
          }
          <div>
            <app-user-presence category="capture" [targetId]="capture.id" />
          </div>
        </td>
        <td class="status-column">
          <strong>{{ capture.status | captureStatus }}</strong>
          <br />
          {{ capture.statusReason | captureStatusReason }}
        </td>
        @if (displayClient) {
          <td>
            {{ capture.client.name }}
            @if (capture.client.state) {
              <span>
                ({{ capture.client.state }})
              </span>
            }
            @if (!capture.client.active) {
              <div class="inactive-client">
                INACTIVE
              </div>
            }
          </td>
        }
        <td>{{ claimSourceDisplay[capture.candidate.source.toLowerCase()] | blankValueDash }}</td>
        <td class="text-center">
          {{ capture.estimatedValueForDisplay }}
          <div class="mt-1 px-1 border">
            <strong>PENDING</strong>
            <div>{{ capture.pendingEstimatedValue | currency: 'USD':'symbol':'1.0-0' }}</div>
          </div>
          <div class="mt-1 px-1 border">
            <strong>WIP</strong>
            <div>{{ capture.wipEstimatedValue | currency: 'USD':'symbol':'1.0-0' }}</div>
          </div>
        </td>
        @if (internalConsultantView) {
          <td class="text-center">
            {{ capture.patientEstimatedValue | currency: 'USD':'symbol':'1.0-0' }}
          </td>
        }
        @if (!internalConsultantView) {
          <td class="text-center">
            <div [ngClass]="{ 'fw-bold': capture.manualFaxSent }">{{ capture.manualFaxSent ? 'Yes' : 'No' }}</div>
            @if (capture.manualFaxSent) {
              <div>{{ capture.mostRecentManualFaxSentAt | date: 'MM/dd/yyyy' }}</div>
            }
          </td>
        }
        <td class="text-end">{{ capture.createdAt | date: 'MM/dd/yyyy' }}</td>
        <td class="text-end">
          <app-expiration-date [expirationDate]="capture.expirationDate" />
        </td>
        @if (!internalConsultantView) {
          <td class="text-end">{{ capture.verifiedAt | date: 'MM/dd/yyyy' }}</td>
        }
        @if (displayPatient) {
          <td>
            <app-patient-name
              [patient]="capture.sourcePatient"
              [showAlternateNames]=false
              [canViewPatient]="true" />
          </td>
        }
        <td><app-candidate-patient-name [candidate]="capture.candidate" /></td>
        @if (displayProvider) {
          <td>
            <app-prescriber-name [provider]="capture.provider" [linkToProvider]="true" />
          </td>
        }
        <td>
          <app-candidate-drug [candidate]="capture.candidate" />
          <div class="small"><strong>SOURCE:</strong> {{ capture.candidate.source }}</div>
        </td>
      </tr>
    }
  </tbody>
</table>
